

import React, { useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const LoginPage = () => {
  const [otpStatus, setOtpStatus] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");

  // let host = "https://api.vmrdarental.com";
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!mobilenumber) {
      alert("Please enter your mobile number");
      return;
    }

    try {
      // Step 1: Send OTP for all users
      const otpResponse = await axios.post(host + "/userotplogin", {
        mobile_number: mobilenumber,
      });

      if (otpResponse.data.status === 200) {
        setOtpStatus(true);
        console.log("OTP Sent Successfully");
      } else {
        alert("Failed to send OTP");
      }
    } catch (error) {
      console.error("OTP Sending Failed:", error.message);
    }
  };

  // ✅ Handle OTP Verification and Login
  const handleVerifyOtp = async () => {
    if (!otp) {
      alert("Please enter OTP");
      return;
    }

    try {
      const otpVerifyResponse = await axios.post(host + "/userverifyotp", {
        otp,
        mobile_number: mobilenumber,
      });

      if (otpVerifyResponse.data.status === 200) {
        alert("OTP Verified Successfully");

        // Step 2: Login after OTP Verification
        const response = await axios.post(host + "/loginuser", {
          mobile_number: mobilenumber,
        });

        if (response.status === 200 && response.data.status === 200) {
          const userData = {
            mobilenumber,
            name: response.data.data[0].name,
          };

          localStorage.setItem("token-info", JSON.stringify(userData));
          localStorage.setItem("userRole", response.data.data[0].user_type);
          localStorage.setItem(
            "access_token",
            response.data.data[0].access_token
          );

          let bookingDetailsData = JSON.parse(
            localStorage.getItem("bookingDetailsData")
          );

          if (
            !bookingDetailsData ||
            !bookingDetailsData.selectedRooms ||
            bookingDetailsData.selectedRooms.length === 0
          ) {
            navigate("/", "_self");
          } else {
            navigate("/previewpage", "_self");
          }
        } else {
          alert("Invalid user or login failed");
        }
      } else {
        alert("Failed to verify OTP");
      }
    } catch (error) {
      console.error("OTP Verification Failed:", error.message);
    }
  };

  return (
    <div>
      <Header />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
            <div className="container mt-2">
              <form className="login-form">
                <h1
                  className="text-center"
                  style={{ fontSize: "25px", color: "green" }}
                >
                  Login
                </h1>
                <div className="mb-3">
                  <label>Mobile Number: </label>
                  <input
                    type="text"
                    value={mobilenumber}
                    onChange={(e) => setMobilenumber(e.target.value)}
                  />
                </div>

                {otpStatus && (
                  <div>
                    <label>Enter OTP: </label>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      onKeyDown={(e) =>
                        e.key === "Enter" && handleVerifyOtp()
                      }
 
                    />
                  </div>
                )}
                <br />
                <button
                  type="button"
                  className="btnss btn-primarys login-button"
                  onClick={otpStatus ? handleVerifyOtp : handleLogin}
                >
                  {otpStatus ? "Verify OTP" : "Send OTP"}
                </button>
                <div className="mt-3" style={{ fontSize: "18px" }}>
                  Not registered? <Link to="/Register">Register now</Link>
                  <br />
                  <div className="mt-3" style={{ marginLeft: "20px" }}>
                    <Link to="/forgot-password">Forgot Password?</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
